import * as Excel from 'exceljs';
import saveAs from 'file-saver';
import * as XLSX from 'xlsx';

import { capitalizeFirstLetter } from './formatter';

export enum EFileExtension {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export const exportEmailSheet = async (
  data: any[],
  fileExtension: EFileExtension,
  filename?: string,
) => {
  const exportData = [...data];
  const wb = new Excel.Workbook();
  const date = new Date();
  const formatedDate = new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
  const dateNow = formatedDate.toISOString().replace(/\.\d{3}Z$/, '');

  if (fileExtension === EFileExtension.XLSX) {
    const worksheet = XLSX.utils.json_to_sheet(
      exportData.map((email) => {
        return {
          email,
        };
      }),
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);

    XLSX.utils.sheet_add_aoa(worksheet, [['E-mail']], { origin: 'A1' });

    worksheet['!cols'] = [{ width: 30 }];

    XLSX.writeFile(workbook, `${filename ?? dateNow}.xlsx`, { compression: true });

    return;
  }

  const ws = wb.addWorksheet();
  const headers = [{ header: 'Email', key: 'em', width: 15 }];
  ws.columns = headers;

  exportData.forEach((value) => {
    ws.addRow([value]);
  });

  exportData.unshift('E-mail');
  const sheetData = exportData.join('\r\n');

  if (fileExtension === EFileExtension.CSV) {
    const file = new File([new Blob([sheetData])], `${filename ?? dateNow}.csv`, {
      type: 'text/csv;charset=utf-8',
    });
    saveAs(file);
    return;
  }
};

export const exportObjectSheet = async (
  data: any[],
  fileExtension: EFileExtension,
  filename?: string,
) => {
  const date = new Date();
  const formatedDate = new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
  const dateNow = formatedDate.toISOString().replace(/\.\d{3}Z$/, '');
  const dataKeys = Object.keys(data[0]);

  if (fileExtension === EFileExtension.XLSX) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates');

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        dataKeys.map((key) => {
          return capitalizeFirstLetter(key);
        }),
      ],
      { origin: 'A1' },
    );

    worksheet['!cols'] = [{ width: 30 }, { width: 100 }];

    XLSX.writeFile(workbook, `${filename ?? dateNow}.xlsx`, { compression: true });

    return;
  }

  if (fileExtension === EFileExtension.CSV) {
    const wb = new Excel.Workbook();
    const ws = wb.addWorksheet();

    const headers = dataKeys.map((key) => {
      return {
        header: key,
        width: 15,
      };
    });
    ws.columns = headers;

    const formattedData = data.map((valor) => {
      const newData = Object.values(valor) as string[];
      return newData.join(';');
    });
    ws.columns = headers;

    formattedData.forEach((value) => {
      ws.addRow([value]);
    });

    formattedData.unshift(
      dataKeys
        .map((key) => {
          return capitalizeFirstLetter(key);
        })
        .join(';'),
    );

    const sheetData = formattedData.join('\r\n');
    const file = new File([new Blob([sheetData])], `${filename ?? dateNow}.csv`, {
      type: 'text/csv;charset=utf-8',
    });

    saveAs(file);
    return;
  }
};

export const importSheet = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);
      resolve(parsedData);
    };
    reader.readAsBinaryString(e.target.files[0]);
  });
};
